import { render, staticRenderFns } from "./PatchRequestForm.vue?vue&type=template&id=348aab08&scoped=true"
import script from "./PatchRequestForm.vue?vue&type=script&lang=js"
export * from "./PatchRequestForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348aab08",
  null
  
)

export default component.exports